import { ReleaseList } from 'services/api/entities';
import ContentState from './components/ContentState';
import LoadMoreButton from './components/LoadMore';

interface PropsType {
  data: ReleaseList;
  isFetching: boolean;
  onLoadMore: () => void;
}

const ReleasesList = ({ data, isFetching, onLoadMore }: PropsType) => (
  <>
    <ContentState data={data} />
    {!data.areAllPagesLoaded && (
      <LoadMoreButton isFetching={isFetching} onLoadMore={onLoadMore} />
    )}
  </>
);

export default ReleasesList;
